var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/movenavigationnode',["require", "exports", "common/parts"], function (require, exports, Parts) {
    "use strict";
    var MoveNavigationNode = (function (_super) {
        __extends(MoveNavigationNode, _super);
        function MoveNavigationNode() {
            _super.apply(this, arguments);
        }
        MoveNavigationNode.prototype.process = function (symbol) {
            try {
                var parent = symbol.item1.parent;
                var sourcePosition = parent.raw.children.indexOf(symbol.item1.raw);
                var targetPosition = sourcePosition + symbol.item2;
                this.moveItem(parent.raw.children, sourcePosition, targetPosition);
                this.moveItem(parent.children, sourcePosition, targetPosition);
                this.output.call(symbol.item1);
            }
            catch (error) {
                this.error.call(error);
            }
        };
        MoveNavigationNode.prototype.moveItem = function (source, sourcePosition, targetPosition) {
            var placeholder = {};
            var objectToMove = source.splice(sourcePosition, 1, placeholder)[0];
            source.splice(targetPosition, 0, objectToMove);
            source.splice(source.indexOf(placeholder), 1);
        };
        return MoveNavigationNode;
    }(Parts.Part));
    return MoveNavigationNode;
});

